import React from "react";
import { Dialog, DialogTitle, DialogContent, DialogContentText, TextField, DialogActions, Button } from "@mui/material";

export function ConfirmationDialog({title, dialogText, closeButtonText, handleActionButtonText, onChangeEvent}: {title: string, dialogText: string, closeButtonText: string, handleActionButtonText: string, onChangeEvent: any}) {
  const [open, setOpen] = React.useState(true);  

  const handleClose = (event, reason) => {
    if (reason !== 'backdropClick' && reason !== 'escapeKeyDown') {      
      setOpen(false);
      onChangeEvent(false);
    }
  };

  const handleAction = () => {
    onChangeEvent(true);
    setOpen(false);
  };  
  
  return (
    <div>
      <Dialog open={open} onClose={handleClose} PaperProps={{ style: { minWidth: "425px" } }}>
        <DialogTitle sx={{ fontWeight: "bold" }}>{title}</DialogTitle>
        <DialogContent>
          <DialogContentText sx={{ color: "rgba(63, 66, 66, 0.767)", whiteSpace: "pre-line" }}>
            {dialogText}
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button id="secondary" variant="outlined" onClick={(e) => handleClose(e, "")}>{closeButtonText}</Button>
          <Button variant="contained" onClick={handleAction}>{handleActionButtonText}</Button>
        </DialogActions>
      </Dialog>
    </div>
  );
}
